export default __webpack_public_path__ + "CircularCustCapNum-Light.c94de3a95b125f0bdf0e7b42e1cb5b8f.ttf";